export default "__VITE_ASSET__CfBSA1$p__"